import {useQuery} from '@tanstack/react-query';
import {API, CHAT_MEDIA_DISPLAY_VARIANT} from '@chekin/api';
import {QUERY_CACHE_KEYS, getFeatureFlags} from '@chekin/core';

const isChatAttachmentsFeatureEnabled = getFeatureFlags('CHE_171_CHAT_ATTACHMENTS');

function useChatAttachmentsEnabled(): boolean {
  const {data} = useQuery({
    queryKey: [QUERY_CACHE_KEYS.communicationUserPreferences],
    queryFn: () => API.communications.getUserPreferences(),
    enabled: isChatAttachmentsFeatureEnabled,
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return (
    isChatAttachmentsFeatureEnabled &&
    data?.chat_media_display_variant === CHAT_MEDIA_DISPLAY_VARIANT.attachments
  );
}

export {useChatAttachmentsEnabled};
